import { AgGridReact } from 'ag-grid-react';
import React, { useEffect } from 'react';
import { StatusStaticCell, titleCell } from '../../../components/elements/function';
import Icon from '../../../components/icons';
import Loader from '../../../components/loader';
import { useNavigate, useParams } from 'react-router-dom';
import { useDepreciationApi } from '../../../store/api/hooks/depreciationApiHook';

import { DATE_FORMAT } from '../../../_common/constant';
import moment from 'moment';
import { useWorkOrderApi } from '../../../store/api/hooks/workOrderApiHook';
import { URLS } from '../../../_config';
import { showLocalDate } from '../../../_common/functions';

interface Props {
_ref:any
}


const AssociateWorkOrder: React.FC<Props> = ({_ref}) => {
    const params: any = useParams();
    const navigate = useNavigate();
    const depreciationAPI = useDepreciationApi();
    const workOrderApi: any = useWorkOrderApi();

    
    const [rowData, setRowData] = React.useState<any[] | null>([]);    


    const columnDefs = [
        {
            headerName: 'Task No', field: 'workOrderCode', headerClass: 'bg-[#f0f0f0]', width: 160, cellRenderer: (data: any) => {
                return (
                    <p className='hover:text-primary font-semibold cursor-pointer'> {data.value}  </p>
                )
            }, onCellClicked: (param: any) => {
                navigate(URLS.WORK_ORDER_DETAILS(param.data.workOrderID));
            }
        },

        { headerName: 'Description', field: 'description', headerClass: 'bg-[#f0f0f0]', width: 140, flex: 1, cellRenderer: titleCell },
        {
            headerName: 'Facility', field: 'facilityName', headerClass: 'bg-[#f0f0f0]', minWidth: 160, cellRenderer: (params: any) => {
                return (
                    <p className='hover:text-primary font-semibold cursor-pointer'>
                        {params.data.facilityName}
                    </p>
                )
            }, tooltipValueGetter: (params: any) => {
                return params.data.facilityName + (params.data.subFacilityName ? `, ${params.data.subFacilityName}` : '')
            }
        },
        {
            headerName: 'Start Date', field: 'startDate', headerClass: 'bg-[#f0f0f0]', width: 140, cellStyle: { textAlign: 'center' }, cellRenderer: (data: any) => {
                return (
                    <p className='hover:text-primary font-semibold cursor-pointer'>
                        {showLocalDate(data.value)}
                    </p>
                )
            }, onCellClicked: (param: any) => {
                navigate(URLS.WORK_ORDER_DETAILS(param.data.workOrderID));
            }, tooltipValueGetter: (params: any) => {
                return +params.data.woStatusID >= 4 ? (
                    //Actual start datetime
                    (params.data.originalStartDate ? moment.utc(params.data.originalStartDate).local().format(`MM/DD/YYYY hh:mm A`) : '')
                ) : (
                    moment.utc(params.data.startDate).local().format(`MM/DD/YYYY hh:mm A`)
                )
            }
        },
        {
            headerName: 'End Date', field: 'endDate', headerClass: 'bg-[#f0f0f0]', width: 140, cellRenderer: (data: any) => {
                return (
                    <p className='hover:text-primary font-semibold cursor-pointer'>{showLocalDate(data.value)}</p>
                )
            }, onCellClicked: (param: any) => {
                navigate(URLS.WORK_ORDER_DETAILS(param.data.workOrderID));
            }, tooltipValueGetter: (params: any) => {
                return +params.data.woStatusID >= 4 ? (
                    //Actual start datetime
                    (params.data.originalEndDate ? moment.utc(params.data.originalEndDate).local().format(`MM/DD/YYYY hh:mm A`) : ``)
                ) : (
                    moment.utc(params.data.endDate).local().format(`MM/DD/YYYY hh:mm A`)
                )
            }
        },
        { headerName: 'Priority', field: 'priorityName', headerClass: 'bg-[#f0f0f0]', width: 160, cellRenderer: titleCell },
        //{ headerName: 'Status', field: 'woStatusName', headerClass: 'bg-[#f0f0f0]' , width: 160,   cellRenderer:titleCell},
        { headerName: 'Status', field: 'woStatusName', headerClass: 'bg-[#f0f0f0]', width: 200, cellRenderer: StatusStaticCell },
        {
            headerName: 'Assignment Type', field: 'woAssignmentTypeName', headerClass: 'bg-[#f0f0f0]', width: 160, cellRenderer: (params: any) => {
                return (
                    <div className='text-ellipsis overflow-hidden' title={`${params.value}`}>{params.value || `--`}</div>
                )
            }
        }
    ];


    const GetGAAPDepreciation = (assetID: any=params.id) => {
        console.log('Hooooooooooo==')
        const payload = {
          assetID: assetID,
        };
        depreciationAPI.GetGAAPDepreciation(
          payload,
          (data: any) => {
            setRowData(data.depreciationList);
          },
          (error: any) => {}
        );
      };

      const init_page_data = async (assetID: any = params.id) => {
        const wodata:any = await new Promise((resolve, reject) => {
            workOrderApi.GetWorkOrderList({
                workRequestID: assetID,
            }, (resp: any) => {
                if (resp && resp.hasOwnProperty("workOrderList") && resp.workOrderList.length > 0) {
                    resolve(resp.workOrderList);
                } else {
                    resolve([]);
                }
            }, (error: any) => {
                reject([]);
            });
        }).catch((err:any) => {
            return [];
        });
        setRowData(wodata);
      };
    
      useEffect(() => {
        if (params.id) {
            //GetGAAPDepreciation(params.id);
            init_page_data(params.id);
        }
      }, [params]);
   
      useEffect(() => {
        if(_ref?.current){
            _ref.current.reload=init_page_data
        }
      
    }, [_ref]);

    return (
        <div ref={_ref} className={ `mt-3` }>
            <div className={ `flex items-center justify-between items-center py-2 mb-0` }>
                <h4 className={ `py-2 pl-1` } style={{ color: `#000`, fontWeight: `bold`, fontSize: 15 }}>Associated Task</h4>
            </div>
            <div className={ `` }>
                <AgGridReact
                    columnDefs={columnDefs} // Pass columnDefs
                    rowData={rowData} // Pass rowData
                    pagination={false}
                    //onGridReady={onGridReady}
                    //onRowClicked={onRowClicked}
                    domLayout="autoHeight"
                    loadingOverlayComponent={Loader}
                />
            </div>
        </div>
    );
};

export default AssociateWorkOrder;